import React from 'react'

export default function ToolsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2328_29350"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2328_29350)">
        <path
          d="M17.8508 19.9496L13.4258 15.5246L15.5258 13.4246L19.9508 17.8496C20.2341 18.1329 20.3758 18.4829 20.3758 18.8996C20.3758 19.3163 20.2341 19.6663 19.9508 19.9496C19.6674 20.2329 19.3174 20.3746 18.9008 20.3746C18.4841 20.3746 18.1341 20.2329 17.8508 19.9496ZM4.05078 19.9496C3.76745 19.6663 3.62578 19.3163 3.62578 18.8996C3.62578 18.4829 3.76745 18.1329 4.05078 17.8496L9.90078 11.9996L8.20078 10.2996C7.98411 10.5163 7.74245 10.6163 7.47578 10.5996C7.20911 10.5829 6.98411 10.4829 6.80078 10.2996L6.22578 9.72461V11.7746L6.05078 11.9496C5.90078 12.0996 5.72578 12.1746 5.52578 12.1746C5.32578 12.1746 5.15078 12.0996 5.00078 11.9496L3.02578 9.97461C2.87578 9.82461 2.80078 9.64961 2.80078 9.44961C2.80078 9.24961 2.87578 9.07461 3.02578 8.92461L3.20078 8.74961H5.25078L4.70078 8.19961C4.50078 7.99961 4.40078 7.76628 4.40078 7.49961C4.40078 7.23294 4.50078 6.99961 4.70078 6.79961L7.55078 3.94961C7.88411 3.61628 8.24245 3.37461 8.62578 3.22461C9.00911 3.07461 9.40078 2.99961 9.80078 2.99961C10.2008 2.99961 10.5924 3.07461 10.9758 3.22461C11.3591 3.37461 11.7174 3.61628 12.0508 3.94961L9.75078 6.24961L10.3008 6.79961C10.4841 6.98294 10.5841 7.20794 10.6008 7.47461C10.6174 7.74128 10.5174 7.98294 10.3008 8.19961L12.0008 9.89961L14.2508 7.64961C14.1841 7.46628 14.1301 7.27461 14.0888 7.07461C14.0468 6.87461 14.0258 6.67461 14.0258 6.47461C14.0258 5.49128 14.3634 4.66194 15.0388 3.98661C15.7134 3.31194 16.5424 2.97461 17.5258 2.97461C17.7758 2.97461 18.0134 2.99961 18.2388 3.04961C18.4634 3.09961 18.6924 3.17461 18.9258 3.27461L16.4508 5.74961L18.2508 7.54961L20.7258 5.07461C20.8424 5.30794 20.9218 5.53694 20.9638 5.76161C21.0051 5.98694 21.0258 6.22461 21.0258 6.47461C21.0258 7.45794 20.6884 8.28694 20.0138 8.96161C19.3384 9.63694 18.5091 9.97461 17.5258 9.97461C17.3258 9.97461 17.1258 9.95794 16.9258 9.92461C16.7258 9.89128 16.5341 9.83294 16.3508 9.74961L6.15078 19.9496C5.86745 20.2329 5.51745 20.3746 5.10078 20.3746C4.68411 20.3746 4.33411 20.2329 4.05078 19.9496Z"
          fill="#999FAC"
        />
      </g>
    </svg>
  )
}
